import * as actions from "../actions";
import axios from "axios";
import { store } from "../../store";
import localTranslations from "../../../translations/Translations.json";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import React from "react";
import { _get } from "../../http";

export let locale = navigator.language.substr(0, 2);

export const translationMode = localStorage.getItem("translationMode") === "true";

export const readCookie = (name) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const getNewTranslations = (translations) => {
  return new Promise((resolve) => {
    let newBackofficeTranslations = localStorage.getItem("new_backoffice_translations");

    if (newBackofficeTranslations != null) {
      newBackofficeTranslations = JSON.parse(newBackofficeTranslations);
      if (newBackofficeTranslations.metadata?.timestamp === parseInt(readCookie("new_backoffice_translations"))) {
        resolve(translations);
        return;
      }
    }
    _get("/core/backofficeTranslations/newTranslations")
      .then((response) => {
        localStorage.setItem("new_backoffice_translations", JSON.stringify(response.data.data));

        delete response.data.data.metadata;
        Object.keys(response.data.data).forEach((lang) => {
          Object.keys(response.data.data[lang]).forEach((key) => {
            translations[lang][key] = response.data.data[lang][key];
          });
        });
        resolve(translations);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

const getTranslations = () => {
  return new Promise((resolve, reject) => {
    let translations = localStorage.getItem("backoffice_translations");

    try {
      translations = JSON.parse(translations);

      if (translations?.metadata?.timestamp === parseInt(readCookie("backoffice_translations"))) {
        if (translationMode) {
          getNewTranslations(translations).then((translations) => {
            resolve(translations);
          });
        } else {
          resolve(translations);
        }
        return;
      }
    } catch (e) {
      console.warn(e);
    }

    let translationsUrl = import.meta.env.VITE_AZURE_STORAGE + "backoffice/translations/translations.json";

    if (import.meta.env.MODE !== "production") {
      translationsUrl =
        import.meta.env.VITE_AZURE_STORAGE +
        "backoffice/translations/" +
        (readCookie("dev_identifier") ?? "DEV") +
        "/translations.json";
    }

    axios
      .get(translationsUrl + "?" + Date.now())
      .then((response) => {
        localStorage.setItem("backoffice_translations", JSON.stringify(response.data));

        if (translationMode) {
          getNewTranslations(response.data).then((translations) => {
            resolve(translations);
          });
        } else {
          resolve(response.data);
        }
      })
      .catch((err) => {
        // If all else fails try to fallback to the local translations file
        try {
          resolve(localTranslations);
        } catch (e) {
          if (import.meta.env.MODE === "development") {
            console.log(err, e);
          }
        }
      });
  });
};

const updateTranslation = (payload) => {
  axios({
    url: "core/backofficeTranslations/updateFromTranslationMode",
    method: "post",
    data: payload,
  }).catch((err) => {
    store.dispatch({
      type: actions.SHOW_MESSAGE,
      message: {
        color: "danger",
        text: (
          <TranslationWrapper
            tDefault={"Something went wrong updating the translation"}
            tKey={"translation_mode.update.failed"}
          />
        ),
      },
    });
  });
};

export const initTranslations = () => {
  getTranslations().then((translations) => {
    // Delete metadata prop so it's not interpreted as a language
    delete translations.metadata;

    const translationData = {
      translations: translations,
      displayedLanguage: localStorage.getItem("displayedLanguage") ?? "en",
      languagesToTranslate: JSON.parse(localStorage.getItem("languagesToTranslate")) ?? ["en"],
      translationMode: translationMode,
      init: true,
    };

    store.dispatch({
      type: actions.INIT_TRANSLATIONS,
      payload: translationData,
    });
  });
};
const initialState = {
  translations: {
    init: false,
  },
};

const translationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.INIT_TRANSLATIONS:
      return {
        ...state,
        ...action.payload,
      };
    //USER ACTIONS
    case actions.UPDATE_TRANSLATIONS:
      updateTranslation(action.payload);

      let copy = { ...state.translations };
      Object.keys(action.payload).forEach((lang) => {
        Object.keys(action.payload[lang]).forEach((key) => {
          copy[lang][key] = action.payload[lang][key];
        });
      });

      return {
        ...state,
        translations: copy,
      };
    case actions.UPDATE_LANGUAGES_TO_TRANSLATE:
      localStorage.setItem("languagesToTranslate", JSON.stringify(action.payload));
      return {
        ...state,
        languagesToTranslate: action.payload,
      };
    case actions.UPDATE_DISPLAYED_LANGUAGE:
      localStorage.setItem("displayedLanguage", action.payload);
      return {
        ...state,
        displayedLanguage: action.payload,
      };
    default:
      return state;
  }
};

export default translationsReducer;
